import React from "react";
import SuccessMessageModal from "@streeteasy/design-system/legacy/SuccessMessageModal";
import { func, object, shape, string } from "prop-types";

const LoggedInUserConfirmation = props => (
  <SuccessMessageModal isOpen onClose={props.handleCloseModal}>
    <SuccessMessageModal.Body>
      <SuccessMessageModal.SuccessIcon />
      <SuccessMessageModal.Title>
        {props.data.confirmationHeader || "Your message was sent"}
      </SuccessMessageModal.Title>
      <SuccessMessageModal.Text>
        {props.data.confirmationText}
      </SuccessMessageModal.Text>
    </SuccessMessageModal.Body>
  </SuccessMessageModal>
);

LoggedInUserConfirmation.propTypes = {
  data: shape({
    confirmationHeader: string,
    confirmationText: object.isRequired
  }).isRequired,
  handleCloseModal: func.isRequired
};

export default LoggedInUserConfirmation;
